import React from "react";

import "./Faq.css";

import { NavLink } from 'react-router-dom';
import { FaLink, FaRegFilePdf } from "react-icons/fa"



const closeFAQitem = function (e) {
    console.log(e, e.target.checked, !e.target.checked, e.target.dataset.checked)

    if (e.target.dataset.checked === 'false') {
        e.target.dataset.checked = 'true';
    } else if (e.target.dataset.checked === 'true') {
        e.target.dataset.checked = 'false';
        e.target.checked = false;
    }


}


const Faq = function () {
    return (
        <React.Fragment>


            <div className="page-body">

                <br></br>
                <div className="page-content">

                    <div className="faq" >
                        <div className="wrapperFAQ">

                            <h1 className="intro-name"><span>Oft gestellte Fragen:</span></h1>
                            <br></br>

                            <div className="faq_items">
                                <input type="radio" id="tab-1" name="tabs" onClick={closeFAQitem} data-checked={false} />
                                <label className="faq-label" for="tab-1"><div>Was ist RKC-Kettlebell?</div><div className="cross"></div></label>
                                <div className="content">
                                    <p>
                                        Das Training mit der Kettlebell steht im direkten Gegensatz zum weit verbreiteten isolierten Training einzelner Muskeln und Muskelgruppen an Kraftmaschinen. Durch den versetzten Schwerpunkt der Kugelhantel muss bei den klassischen Kettlebell Übungen nahezu die gesamte Körpermuskulatur eingesetzt werden um das Gewicht unter Kontrolle zu halten. Besonders fördernd ist dieses Training für die Rumpfstabilität, also die Kraft im Bereich der Lendenwirbelsäule und dem Hüftbereich. Kettlebell Training steht für funktionale Kraft, Explosivität, Flexibilität und intensives Herz-Kreislauftraining und ist besonders im Kampfsport weit verbreitet. Kettlebells können einerseits als reine Trainingsgewichte (ähnlich wie Kurzhanteln) eingesetzt werden, typisch sind jedoch dynamische Schwungübungen. Hier entstehen durch die auftretende Fliehkraft enorm hohe Kräfte.
                                    </p>
                                    <p>
                                        Kettlebells sind runde aus Eisen gefertigte Gewichtskugeln, die mit einem Griff versehen sind. Anders als bei normalen Hanteln befindet sich hier der Masseschwerpunkt außerhalb der Hand. Charakteristisch sind spezielle Schwungübungen, wie z.B. der Swing oder der Snatch. Diese ballistischen Techniken sind hauptsächlich für die Effektivität und Popularität dieser einfachen Trainingsmittel verantwortlich, da sie neben einer funktionellen muskulären Belastung auch eine enorm hohe Belastung für das Herz-Kreislauf-System darstellen. Typisch sind kurze aber zugleich intensive Workouts, in denen gleichzeitig die motorischen Hauptbeanspruchungsformen Kraft, Ausdauer, Koordination und Beweglichkeit trainiert werden. Egal ob Leistungssportler oder Anfänger,das Kettlebelltraining ist grenzenlos.
                                    </p>
                                    <p>
                                        Hardstyle-Kettlebell wurde von Pavel Tsatsouline, einem aus Russland stammenden ehemaligen Ausbilder für Sondereinheiten bekannt gemacht. Bei dieser besonderen Form des Kettlebell Trainings wird der traditionelle russische Kettlebell-Sport nach den Prinzipien des besonders hart geltenden Kyokushin Karate-Stils ausgeübt, um den Trainingsreiz zu maximieren.
                                    </p>
                                    <p>
                                        Pavel und das amerikanische Verlagshaus Dragondoor Publications haben daraufhin die Russian Kettlebell Challenge (RKC) ausgerufen. Seit 15 Jahren veranstalten sie unter dem Namen RKC Kettlebell-Instruktorenausbildungen.
                                    </p>
                                    <p>
                                        Allein die Tatsache, dass die Organisation bereits so lange existiert und noch immer wächst, ist, wenn man den Fitnessmarkt kennt, ein Phänomen.
                                    </p>
                                </div>
                            </div>

                            <div className="faq_items">
                                <input type="radio" id="tab-2" name="tabs" onClick={closeFAQitem} data-checked={false} />
                                <label className="faq-label" for="tab-2"><div>Was muss ich zum Thaibox-Training mitbringen?</div><div className="cross"></div></label>
                                <div className="content">
                                    <p>Kampfkleidung besteht aus:</p>
                                    <ol>
                                        <li>Boxhandschuhe</li>
                                        <li>Boxbandagen</li>
                                        <li>Mundschutz</li>
                                        <li>Tiefschutz</li>
                                        <li>Muay Thai Shorts</li>
                                        <li>Ellenbogenschützer</li>
                                        <li>Schienbeinschoner</li>
                                        <li>Fußbandagen</li>
                                    </ol>
                                    <p>Ein vollständiges Equipment wird beim Probetraining und den ersten Trainingseinheiten nicht benötigt. Boxhandschuhe mit den entsprechenden Boxbandagen sind allerdings vom Vorteil aber kein Muss. Wenn die Entscheidung getroffen ist dem Verein beizutreten, sollte nach und nach die Kampfkleidung ergänzt werden.</p>
                                    <p>Aus hygienischen Gründen verleihen wir kein Equipment.</p>

                                </div>
                            </div>

                            <div className="faq_items">
                                <input type="radio" id="tab-3" name="tabs" onClick={closeFAQitem} data-checked={false} />
                                <label className="faq-label" for="tab-3"><div>Gibt es bestimmte Voraussetzungen, um am Thaibox-Training teilzunehmen?</div><div className="cross"></div></label>
                                <div className="content">
                                    <p>Nein, es gibt keine Voraussetzungen, um am Thaibox-Training teilzunehmen. Alle notwendigen Techniken werden in einem regelmäßigen Training erlernt und verbessert. Auch konditionell müssen keine Voraussetzungen erfüllt werden. Ebenso ist es nicht notwendig vor dem Training Gewicht zu reduzieren oder mit dem Krafttraining anzufangen.</p>
                                </div>
                            </div>

                            <div className="faq_items">
                                <input type="radio" id="tab-4" name="tabs" onClick={closeFAQitem} data-checked={false} />
                                <label className="faq-label" for="tab-4"><div>Wann findet das Muay Thai/K1 Training statt?</div><div className="cross"></div></label>
                                <div className="content">
                                    <div class='tab'>
                                        <table border='0' cellpadding='0' cellspacing='0'>
                                            <tr class='days'>
                                                <th></th>
                                                <th>Montag</th>
                                                <th>Dienstag</th>
                                                <th>Mittwoch</th>
                                                <th>Donnerstag</th>
                                                <th>Freitag</th>
                                            </tr>
                                            <tr>
                                                <td class='time'>18:00</td>
                                                <td></td>
                                                <td rowspan="3" class='cs335 red2' data-tooltip='Muay Thai/K1 Fortgeschrittene  18:00 bis 19:30'>Muay Thai/K1 Fortgeschrittene</td>
                                                <td></td>
                                                <td rowspan="3" class='cs335 red2' data-tooltip='Muay Thai/K1 Fortgeschrittene  18:00 bis 19:30'>Muay Thai/K1 Fortgeschrittene</td>
                                                <td rowspan="3" class='cs335 red2' data-tooltip='Muay Thai/K1 Fortgeschrittene  18:00 bis 19:30'>Muay Thai/K1 Fortgeschrittene</td>

                                            </tr>
                                            <tr>
                                                <td class='time'>18:30</td>
                                                <td></td>
                                                <td></td>




                                            </tr>
                                            <tr>
                                                <td class='time'>19:00</td>
                                                <td></td>
                                                <td></td>




                                            </tr>
                                            <tr>
                                                <td class='time'>19:30</td>
                                                <td rowspan="3" class='cs335 red2' data-tooltip='Muay Thai/K1 Fortgeschrittene  19:30 bis 21:00'>Muay Thai/K1 Fortgeschrittene</td>
                                                <td rowspan="3" class='cs335 red1' data-tooltip='Muay Thai/K1 Anfänger  19:30 bis 21:00'>Muay Thai/K1 Anfänger</td>
                                                <td rowspan="3" class='cs335 red2' data-tooltip='Muay Thai/K1 Fortgeschrittene  19:30 bis 21:00'>Muay Thai/K1 Fortgeschrittene</td>
                                                <td rowspan="3" class='cs335 red1' data-tooltip='Muay Thai/K1 Anfänger  19:30 bis 21:00'>Muay Thai/K1 Anfänger</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td class='time'>20:00</td>
                                                <td></td>




                                            </tr>
                                            <tr>
                                                <td class='time'>20:30</td>
                                                <td></td>





                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div className="faq_items">
                                <input type="radio" id="tab-5" name="tabs" onClick={closeFAQitem} data-checked={false} />
                                <label className="faq-label" for="tab-5"><div>Wie kann ich mich für ein Probetraining anmelden?</div><div className="cross"></div></label>
                                <div className="content">
                                    <p>Wenn du Interesse an einem Probetraining hast, melde dich bitte telefonisch bei <NavLink className="underline cs-text-link" to="/impressum" exact="true"><FaLink className="icon-link-text " /> uns</NavLink> und wir besprechen alles Weitere.</p>
                                </div>
                            </div>


                        </div>


                    </div>



                </div>





            </div>




        </React.Fragment >
    );
};

export default Faq;